export default "__VITE_ASSET__BUZSGEr___"